import React, { useEffect, useRef } from 'react';

// Ukotvený vrch stránky: hlavička + prepínač okruhov. Výšku zapisuje do CSS
// premennej --top-h, aby sa ľavý panel dashboardu ukotvil tesne pod ním
// (výška sa mení: prepínač nemusí byť, na mobile je hlavička vyššia).
// Na mobile `position: sticky` nefunguje — #root má kvôli iOS overflow-x: hidden
// (mobile.css) — preto je tam prepínač `fixed` a hlavička odsadená o --bar-h.
export default function StickyTop({ children }: { children: React.ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const apply = () => {
      const root = document.documentElement.style;
      root.setProperty('--top-h', `${el.offsetHeight}px`);
      // Výška samotnej hlavičky — na mobile sa odskroluje a ukotvený ostane len prepínač.
      // Výška prepínača okruhov — na mobile je fixne hore a hlavička sa posúva pod neho.
      root.setProperty('--bar-h', `${(el.querySelector('.acc-bar') as HTMLElement | null)?.offsetHeight || 0}px`);
    };
    apply();
    const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(apply) : null;
    ro?.observe(el);
    // Prepínač sa vykreslí až po načítaní účtov; fixný prvok veľkosť obalu nezmení.
    const mo = new MutationObserver(apply);
    mo.observe(el, { childList: true, subtree: true });
    window.addEventListener('resize', apply);
    return () => { ro?.disconnect(); mo.disconnect(); window.removeEventListener('resize', apply); };
  }, []);
  return <div ref={ref} className="sticky-top">{children}</div>;
}
